
import { Card, CardContent } from '@/components/ui/card';

const MobileTargetSection = () => {
  const targetAudiences = [
    {
      title: 'Startups Scaling Operations',
      description: 'Growing businesses that need reliable mobile infrastructure as they expand their teams.'
    },
    {
      title: 'Remote Teams',
      description: 'Distributed workforces requiring reliable mobile data and communication solutions.'
    },
    {
      title: 'Field Teams & Sales Crews',
      description: 'Field technicians, sales teams, and delivery crews who depend on mobile connectivity.'
    },
    {
      title: 'Small-to-Medium Businesses',
      description: 'Companies wanting better support and service than what retail stores typically provide.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            For Whom?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our T-Mobile business solutions are designed for organizations that value reliable service and dedicated support.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          {targetAudiences.map((audience, index) => (
            <Card key={audience.title} className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {audience.title}
                </h3>
                <p className="text-gray-600">
                  {audience.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileTargetSection;
